import { getAuth } from "firebase/auth";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CreateCourse from "../../../../Controllers/Admin/ClassAndCourses/CreateCourse";
import GetSingleCourse from "../../../../Controllers/Admin/ClassAndCourses/GetSingleCourse";
import UpdateCourse from "../../../../Controllers/Admin/ClassAndCourses/UpdateCourse";
import GetSchoolTeachers from "../../../../Controllers/Auth/GetSchoolTeachers";
import GetSingleUser from "../../../../Controllers/Auth/GetSingleUser";

export default function AddCourseViewModel() {
  const [TeachersArray, setTeachersArray] = useState([]);

  const navigate = useNavigate();
  let location = useLocation();

  const [AuthUser, setAuthUser] = useState();
  const [UserObject, setUserObject] = useState({});
  const [TeacherID, setTeacherID] = useState("");

  const [CourseIDError, setCourseIDError] = useState(false);
  const [CourseNameError, setCourseNameError] = useState(false);
  const [TeacherError, setTeacherError] = useState(false);
  const [TotalClassesInWeekError, setTotalClassesInWeekError] = useState(false);

  const [FormDisabled, setFormDisabled] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);
  const [CourseID, setCourseID] = useState("");

  const [IsCheckError, setIsCheckError] = useState(false);
  const [AddCourse, setAddCourse] = useState({
    CourseID: "",
    CourseName: "",
    TotalClassesInWeek: 0,
  });

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setCourseID(LocationArray.pop());

    if (LocationArray.includes("update")) {
      setIsUpdate(true);
      const fetchData = async () => {
        const CourseData = await GetSingleCourse(CourseID);
        setAddCourse({
          CourseID: CourseData?.CourseID,
          CourseName: CourseData?.CourseName,
          TotalClassesInWeek: CourseData?.TotalClassesInWeek,
        });
      };
      fetchData();
    } else {
    }
  }, [location.pathname, CourseID]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        setAuthUser(user);
      });
    }
    fetchData();
  }, []);

  // Teachers Array Start
  useEffect(() => {
    let schoolId = localStorage.getItem("schoolId");

    if (schoolId) {
      schoolId = JSON.stringify(schoolId);
      console.log("schoolId ", schoolId);

      async function fetchData() {
        const teachersArray = await GetSchoolTeachers(schoolId);

        setTeachersArray(teachersArray);
      }
      fetchData();
    }
  }, []);

  // Get Single User Start
  useEffect(() => {
    async function fetchData() {
      const UserData = await GetSingleUser(TeacherID);
      setUserObject(UserData);
    }
    fetchData();
  }, [TeacherID]);
  // Get Single User End

  const UIErrorHandling = useCallback(() => {
    let flag = 0;

    if (
      AddCourse.CourseID === "" ||
      AddCourse.CourseID === null ||
      AddCourse.CourseID === undefined
    ) {
      setCourseIDError(true);
      flag++;
    } else {
      setCourseIDError(false);
    }

    if (
      AddCourse.CourseName === "" ||
      AddCourse.CourseName === null ||
      AddCourse.CourseName === undefined ||
      AddCourse.CourseName.length < 3
    ) {
      setCourseNameError(true);
      flag++;
    } else {
      setCourseNameError(false);
    }

    if (
      AddCourse.TotalClassesInWeek === "" ||
      AddCourse.TotalClassesInWeek === null ||
      AddCourse.TotalClassesInWeek === undefined ||
      AddCourse.TotalClassesInWeek < 1
    ) {
      setTotalClassesInWeekError(true);
      flag++;
    } else {
      setTotalClassesInWeekError(false);
    }

    if (UserObject === undefined) {
      setTeacherError(true);
      flag++;
    } else {
      setTeacherError(false);
    }
    if (UserObject !== undefined) {
      if (
        // AddCourse.Teacher === "" ||
        // AddCourse.Teacher === null ||
        // AddCourse.Teacher === undefined

        Object.keys(UserObject).length === 0
      ) {
        setTeacherError(true);
        flag++;
      } else {
        setTeacherError(false);
      }

      return flag;
    }
  }, [
    AddCourse.CourseID,
    AddCourse.CourseName,
    AddCourse.TotalClassesInWeek,
    UserObject,
  ]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  const RegisterCourse = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();
    console.log("flag", flag);
    if (flag === 0) {
      setFormDisabled(true);
      if (IsUpdate) {
        const CourseFinalObject = {
          ...AddCourse,
          UserObject,
        };

        await UpdateCourse(CourseFinalObject, CourseID)
          .then(() => {
            navigate(-1);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const CourseFinalObject = {
          ...AddCourse,
          Teacher: UserObject,
        };
        await CreateCourse(CourseFinalObject, AuthUser.uid, CourseID)
          .then(() => {
            navigate(-1);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setFormDisabled(false);
    }
  };

  return {
    RegisterCourse,
    FormDisabled,
    AddCourse,
    setAddCourse,
    CourseIDError,
    CourseNameError,
    TeacherError,
    IsUpdate,
    TeachersArray,
    setTeacherID,
    TotalClassesInWeekError,
    setTotalClassesInWeekError,
  };
}
